import { useLayoutEffect, useRef, useState } from "react";
import { Tooltip } from "antd";

const CELL_STYLE = {
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
};

const EllipsisCell = ({ children, title }) => {
  const ref = useRef(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  // Re-measure after every render. Column resizes already re-render each cell,
  // so a per-cell ResizeObserver would just be 1000+ redundant observers on
  // big tables. `prev === next` is what keeps the no-deps form from looping.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useLayoutEffect(() => {
    const node = ref.current;
    if (!node) return;
    const next = node.scrollWidth > node.clientWidth;
    setIsOverflowing((prev) => (prev === next ? prev : next));
  });

  // Empty title suppresses Ant's popup, so the tooltip only shows when truncated.
  const tooltipTitle = isOverflowing ? (title ?? children) : "";

  return (
    <Tooltip title={tooltipTitle} placement="topLeft">
      <div ref={ref} style={CELL_STYLE}>
        {children}
      </div>
    </Tooltip>
  );
};

export default EllipsisCell;
